import { IPermitDocs } from '../../../APIPackage/DictionariesModule/interfaces/IPermitDocs';
import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

/**
 * Генерация списка опций для селекта разрешительных документов
 */
export const createDictionaryPermitDocsSelectOption = makeCreateDictionarySelectOption<IPermitDocs>(
  'targetId',
  'targetTitle',
);
